import React, { ReactNode } from 'react'
import styled from 'styled-components'

type ModalProps = {
  isOpen: boolean
  onClose: () => void
  children: ReactNode
  width?: string
  height?: string
}

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 24px;
`

const ModalContainer = styled.div<{ width?: string; height?: string }>`
  background-color: white;
  border-radius: 10px;
  width: ${({ width }) => width || '520px'};
  height: ${({ height }) => height || 'auto'};
  position: relative;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  max-width: calc(100vw - 48px);
  max-height: calc(100vh - 48px);
  overflow: auto;
`

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, width, height }) => {
  if (!isOpen) return null

  return (
    <Backdrop onClick={onClose}>
      <ModalContainer
        width={width}
        height={height}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </ModalContainer>
    </Backdrop>
  )
}

export default Modal
